import "./tabs.scss"

export default {
  activeTab: "active",
  inactiveTab: "",
  header: "page-header",
  tabList: "nav nav-tabs",
  tabListRole: "tablist",
  tabRole: "tab",
  tabs: "tab-list",
};
